(function () {
  "use strict";

  var FYF_DATA = {
    // ===== MEN =====
    "tank-top": {
      men: {
        headers: ["Size", "Length (cm)", "Width (cm)"],
        note: "Relaxed Fit · True to size recommended.",
        rows: [
          ["M",  60, 39],
          ["L",  62, 39],
          ["XL", 64, 40],
          ["XXL",66, 46]
        ],
        chestRanges: {
          M:   [88, 96],
          L:   [96, 104],
          XL:  [104, 112],
          XXL: [112, 124]
        }
      }
    },
    "ringer-tshirt": {
      men: {
        headers: ["Size", "Length (cm)", "Width (cm)", "Sleeve (cm)"],
        note: "Regular Fit · True to size recommended.",
        rows: [
          ["M",  68, 53, 19],
          ["L",  69, 54, 21],
          ["XL", 70, 57, 23],
          ["XXL",72, 58, 24]
        ],
        chestRanges: {
          M:   [88, 96],
          L:   [96, 104],
          XL:  [104, 114],
          XXL: [114, 124]
        }
      }
    },
    "vneck-tee": {
      men: {
        headers: ["Size", "Length (cm)", "Width (cm)", "Sleeve (cm)"],
        note: "Slim Fit · Size up for a relaxed look.",
        rows: [
          ["M",  64, 47, 18],
          ["L",  65, 51, 19],
          ["XL", 69, 53, 20],
          ["XXL",71, 54, 21]
        ],
        chestRanges: {
          M:   [84, 92],
          L:   [92, 100],
          XL:  [100, 108],
          XXL: [108, 118]
        }
      }
    },
    "pants": {
      men: {
        headers: ["Size", "Width (cm)", "Thigh (cm)", "Length (cm)"],
        note: "Wide Leg Fit · High rise · True to size recommended.",
        rows: [
          ["L",  45, 32, 104],
          ["XL", 50, 34, 106],
          ["XXL",55, 36, 108]
        ],
        chestRanges: {
          L:   [80, 90],
          XL:  [90, 100],
          XXL: [100, 114]
        }
      },
      // ===== WOMEN =====
      women: {
        headers: ["Size", "Width (cm)", "Thigh (cm)", "Length (cm)"],
        note: "Wide Leg Fit · High rise · True to size recommended.",
        rows: [
          ["L",  45, 32, 104],
          ["XL", 50, 34, 106],
          ["XXL",55, 36, 108]
        ],
        chestRanges: {
          L:   [80, 90],
          XL:  [90, 100],
          XXL: [100, 114]
        }
      }
    },
   "tops": {
  women: {
    headers: ["One Size · Fits up to 75 kg."],
    note: "One Size · Fits up to 75 kg.",
    rows: [
      ["One Size"]
    ],
    chestRanges: {
      "One Size": [60, 130]
    }
  }
}
};

  var state = {
    gender: "men",
    category: "tank-top"
  };

  /* ============================================
     RENDER TABS based on gender
  ============================================ */
  function getTabsForGender(gender) {
    if (gender === "men") {
      return [
        { key: "tank-top",      label: "Tank-Top" },
        { key: "ringer-tshirt", label: "Ringer T-Shirt" },
        { key: "vneck-tee",     label: "V-Neck Tee" },
        { key: "pants",         label: "Pants" }
      ];
    } else {
      return [
        { key: "tops",  label: "Tops" },
        { key: "pants", label: "Pants" }
      ];
    }
  }

  function renderTabs() {
    var tabsContainer = document.getElementById("fyf-tabs");
    if (!tabsContainer) return;

    var tabs = getTabsForGender(state.gender);
    state.category = tabs[0].key;

    tabsContainer.innerHTML = tabs
      .map(function (tab, i) {
        return (
          '<button class="fyf-tab' + (i === 0 ? " active" : "") + '" data-category="' + tab.key + '">' +
          tab.label +
          "</button>"
        );
      })
      .join("");

    var tabBtns = tabsContainer.querySelectorAll(".fyf-tab");
    tabBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        tabBtns.forEach(function (b) { b.classList.remove("active"); });
        btn.classList.add("active");
        state.category = btn.getAttribute("data-category");
        renderTable();
        document.getElementById("fyf-result").hidden = true;
      });
    });
  }

  /* ============================================
     RENDER TABLE
  ============================================ */
  function renderTable() {
    var categoryData = FYF_DATA[state.category];
    if (!categoryData) return;
    var data = categoryData[state.gender];
    if (!data) return;

    var headRow = document.getElementById("fyf-table-head");
    var body    = document.getElementById("fyf-table-body");
    var note    = document.getElementById("fyf-fit-note");

    headRow.innerHTML = data.headers
      .map(function (h) { return "<th>" + h + "</th>"; })
      .join("");

    body.innerHTML = data.rows
      .map(function (row) {
        return (
          "<tr>" +
          row.map(function (cell) { return "<td>" + cell + "</td>"; }).join("") +
          "</tr>"
        );
      })
      .join("");

    note.textContent = data.note;
  }

  /* ============================================
     FIT FINDER LOGIC
  ============================================ */
  function estimateBodyMeasurement(heightCm, weightKg) {
    var bmi  = weightKg / Math.pow(heightCm / 100, 2);
    var base = 70 + (bmi - 18) * 2.2 + (heightCm - 165) * 0.15;
    return Math.round(base);
  }

  function findSizeFromMeasurement(measurement, ranges) {
    var order = Object.keys(ranges);
    var matchIndex = order.findIndex(function (size) {
      var range = ranges[size];
      return measurement >= range[0] && measurement < range[1];
    });

    if (matchIndex === -1) {
      if (measurement < ranges[order[0]][0]) matchIndex = 0;
      else matchIndex = order.length - 1;
    }

    return order[matchIndex];
  }

  function runFitFinder() {
    var heightInput = document.getElementById("fyf-height");
    var weightInput = document.getElementById("fyf-weight");
    var resultBox   = document.getElementById("fyf-result");
    var resultSize  = document.getElementById("fyf-result-size");

    var height = parseFloat(heightInput.value);
    var weight = parseFloat(weightInput.value);

    var heightInvalid = !height || height < 100 || height > 230;
    var weightInvalid = !weight || weight < 30  || weight > 200;

    heightInput.style.borderColor = heightInvalid ? "#ff6b6b" : "rgba(255,255,255,0.2)";
    weightInput.style.borderColor = weightInvalid ? "#ff6b6b" : "rgba(255,255,255,0.2)";

    if (heightInvalid || weightInvalid) return;

    var categoryData = FYF_DATA[state.category];
    if (!categoryData) return;
    var data = categoryData[state.gender];
    if (!data) return;

    var measurement = estimateBodyMeasurement(height, weight);
    var size        = findSizeFromMeasurement(measurement, data.chestRanges);

    resultSize.textContent = size;
    resultBox.hidden = false;
  }

  /* ============================================
     EVENT BINDING
  ============================================ */
  function bindEvents() {
    var genderBtns = document.querySelectorAll(".fyf-gender-btn");
    genderBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        genderBtns.forEach(function (b) { b.classList.remove("active"); });
        btn.classList.add("active");
        state.gender = btn.getAttribute("data-gender");
        renderTabs();
        renderTable();
        document.getElementById("fyf-result").hidden = true;
      });
    });

    var submitBtn = document.getElementById("fyf-submit");
    if (submitBtn) submitBtn.addEventListener("click", runFitFinder);

    ["fyf-height", "fyf-weight"].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.addEventListener("keydown", function (e) {
        if (e.key === "Enter") runFitFinder();
      });
    });
  }

  function init() {
    renderTabs();
    renderTable();
    bindEvents();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
